import makeRequest from 'api/makeRequest';
import environment from 'environment';
import HttpStatus from 'http-status-codes';

export async function fetchSSOConfig(email) {
  try {
    const response = await makeRequest(`${environment.services.authServiceUrl}/v1/sso/config/${email}`, {
      method: 'GET',
      skipErrorProcessing: true,
    });

    return response?.config;
  } catch (e) {
    if (e.response?.status === HttpStatus.NOT_FOUND) {
      return null;
    }

    throw e;
  }
}

export async function login(idToken, clientId) {
  return makeRequest(`${environment.services.authServiceUrl}/v1/sso/login`, {
    method: 'POST',
    data: { idToken, clientId },
  });
}
